export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14781.fecc51ab.jpg";